import { Navigate } from "react-router-dom";
import { WEB_ROUTES } from "../../constants";
import { useAuth } from "../../context/AuthContext";

function ProtectedRoute({ children }) {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? children : <Navigate to={WEB_ROUTES.ACCOUNT} replace />;
}

export default ProtectedRoute;
